<template>
    <h3>sadfsd</h3>
</template>
<template>
    <section class="chart-container">


        <el-row>
            <el-col :span="24" class="toolbar" style="padding:0" >
			<el-form  :inline="true"  style="float: right;padding-top:10px" @submit.native.prevent>
            <!-- <el-form-item v-if="value=='2'">
                <el-date-picker
                v-model="yearValue"
                type="year"
                 placeholder="选择年份">
             </el-date-picker>
            </el-form-item>
            <el-form-item v-if="value=='1'">
                <el-date-picker
                    v-model="monthValue"
                    type="month"
                    placeholder="选择月份">
                </el-date-picker>
            </el-form-item>
            <el-form-item v-if="value=='0'">
                <el-date-picker
                   v-model="weekValue"
                   type="week"
                   format="yyyy 第 WW 周"
                   placeholder="选择周">
               </el-date-picker>
            </el-form-item>
                
               <el-form-item >
                  <el-select v-model="value" placeholder  placeholder="请选择视图类型" style="width:192px">
                <el-option
                     v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                </el-option>
                 </el-select>
				</el-form-item>				 -->
 				<el-form-item v-if="TenancyId=='0'||TenancyId==null">
                <el-select  v-model="shopId" clearable filterable placeholder="选择或搜索门店" >
                 <el-option
               v-for="item in optionsShop"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>				
                   </el-form-item>
               
                 <el-form-item>
                    <div class="block">
                   <el-date-picker
                        v-model="dateValue"
                         type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                   </el-date-picker>
                    </div>
                   </el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="generate" icon="el-icon-search">生成统计</el-button>
				</el-form-item>			
			</el-form>
		</el-col>
                <el-col :span="24">
                <div id="FLowchartLine4" style="width:100%; height:400px;"></div>
            </el-col>
        </el-row> 
    </section>     
</template>

<script>

import {GetBusinessEcharts,getShopInfor} from '../../../api/api';
import {mapGetters} from 'vuex';

  import echarts from 'echarts'

    export default {
        data() {
            return {
        TenancyId:'',
        shopId:'',
        optionsShop:[],

                dateValue:'',
                chartLine: null, 
                legendData:[],     
                 xAxisData:[],
                 series:[],
                 options: [{
                     value: '0',
                    label: '周视图'
                    }, {
                      value: '1',
                     label: '月视图'
                    }, {
                     value: '2',
                     label: '年视图'
                    } ],
                    value: '1',
                    weekValue:'',
                    monthValue:'',
                    yearValue:'',
                             pickerOptions: {
              shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },

             }
        },
        
        methods:{
            ...mapGetters(['getuserstate']),
          getShopList()
        {
            let para={}
            getShopInfor(para).then((res) => {                  
                    this.optionsShop = res.data;
				})
				 .catch(error=>{
                 alert('网络错误');
                });          				
        },            
             generate()
                      {
                   
                            this.StatisticsData();
                      },
              drawLineChart() {
                //   console.log("11");
                this.chartLine = echarts.init(document.getElementById('FLowchartLine4'));
          
                this.chartLine.setOption({
                    title: {
                        text: '办理量统计'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    // legend: {
                    //     // data: ['邮件营销', '联盟广告', '搜索引擎','邮件营销1', '联盟广告1', '搜索引擎1']
                    //     data:this.legendData
                    // },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
    xAxis: {
        type: 'category',
        data:this.xAxisData
    },
    yAxis: {
        type: 'value'
    },
    series: [{
        data: this.series,
        type: 'line'
    }]                    // series: [
                    //     {
                    //         name: '次卡',
                    //         type: 'line',
                    //         stack: '总量',
                    //         data: [0, 132, 0, 134, 0, 230, 0]
                    //     },
                    //     {
                    //         name: '月卡',
                    //         type: 'line',
                    //         stack: '总量',
                    //         data: [182, 0, 191, 0, 290, 0, 310]
                    //     },
                    //     {
                    //         name: '年卡',
                    //         type: 'line',
                    //         stack: '总量',
                    //         data: [0, 932, 0, 934, 0, 1330, 0]
                    //     },
                    //      {
                    //         name: '充值卡',
                    //         type: 'line',
                    //         stack: '总量',
                    //         data: [132, 0, 101, 0, 90, 0, 210]
                    //     },
                    //     {
                    //         name: '培训卡',
                    //         type: 'line',
                    //         stack: '总量',
                    //         data: [0, 182, 0, 234, 0, 330, 0]
                    //     },
                        // {
                        //     name: '搜索引擎1',
                        //     type: 'line',
                        //     stack: '总量',
                        //     data: [820, 932, 901, 934, 1290, 1330, 1320]
                        // }
                    // ]
                });
                console.log("222");
            },
            drawCharts() {
               this.drawLineChart();
            },   
             StatisticsData(){
                 
               if(this.dateValue.length<1)
                {
                         this.$message({
							message: "请先选择时间",
							type: 'error'
                        });                   
                    return;
                }
				let Params = {
                    StartDate:this.dateValue[0],
                    EndDate:this.dateValue[1],
                     TenancyId:this.shopId
                   
				};            
                    GetBusinessEcharts(Params).then((res)=>{
                       console.log(res.data.Data);
                        // this.legendData=res.data.Data.LegendData;
                        this.xAxisData=res.data.Data.XAxis;
                        this.series=res.data.Data.SeriesData;
                        this.drawLineChart();
					 }).catch(error=>{
                     alert('网络错误');
                   })
			     	}							        	              
      },
        created(){	               	
		},
        mounted: function () {
                       this.getShopList();
                     this.TenancyId=JSON.parse(this.getuserstate()).TenancyId;
              this.drawLineChart()
        },
        updated: function () {
            this.drawLineChart()
        }
}

</script>
<style scoped>
    .chart-container {
        width: 100%;
        float: left;
    }
    .chart div {
        height: 100%;
        float: left;
    }

    .el-col {
        padding: 30px 20px;
    }
</style>

            




// WEBPACK FOOTER //
// chartBar.vue?66836cc6